import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'

/**
 *  Rounded button base for all UI buttons
 */
class UIButton extends React.Component {
  constructor(props) {
    super(props)
  }

  onClick() {
    const { addHowlSound, action } = this.props
    action && action()
    addHowlSound('button_click_icon')
  }

  render() {
    const { icon, intl, position, id } = this.props
    return (
      <div key={id} id={id ? id : null} className={position}>
        <div
          className="btn"
          title={intl.formatMessage({ id: `ui.${id}` })}
          onClick={() => this.onClick()}
        >
          <div className="btn--primary">
            <span className={icon}></span>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  }
}

UIButton.propTypes = {
  icon: PropTypes.string,
  id: PropTypes.string,
  action: PropTypes.func,
  position: PropTypes.string,
  addHowlSound: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(injectIntl(UIButton))
